var map = {
	"./android/DeviceSetup": 1417,
	"./androidtv/DeviceSetup": 1418,
	"./arris/DeviceSetup": 1419,
	"./hisense/DeviceSetup": 1420,
	"./kepler/DeviceSetup": 1421,
	"./lg/DeviceSetup": 1422,
	"./nagra/DeviceSetup": 1424,
	"./netrange/DeviceSetup": 1425,
	"./opera/DeviceSetup": 1426,
	"./polaroid/DeviceSetup": 1427,
	"./ps4/DeviceSetup": 1428,
	"./samsung/DeviceSetup": 1429,
	"./seirobotics/DeviceSetup": 1430,
	"./sony/DeviceSetup": 1431,
	"./stbcoship/DeviceSetup": 1432,
	"./stbcoship9108/DeviceSetup": 1433,
	"./stbhuawei/DeviceSetup": 1434,
	"./stbkaon/DeviceSetup": 1435,
	"./tizen/DeviceSetup": 1436,
	"./web0s/DeviceSetup": 1437,
	"./workstation/DeviceSetup": 1439,
	"./workstationChafari/DeviceSetup": 1440,
	"./zeasn/DeviceSetup": 1441,
	"./zte/DeviceSetup": 1442
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1416;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/DeviceSetup$
// module id = 1416
// module chunks = 0